/**
 * Shared button styling.
 *
 * Primary actions had split into two looks: the brand gradient (header
 * "Register", JobCard "Apply", Contact submit, the About/Careers CTAs) and a
 * flat talexo-blue (every auth form). Importing from here keeps them identical.
 *
 * `bg-gradient-to-br from-talexo-blue to-talexo-purple` is the Tailwind
 * equivalent of the `linear-gradient(135deg, #0AAAE6 0%, #6428AA 100%)` used
 * inline elsewhere, so both spellings render the same ramp.
 *
 * Colour and state only — each call site keeps its own width, padding and
 * layout classes, since button sizing legitimately differs by context.
 */
export const PRIMARY_BTN =
    'bg-gradient-to-br from-talexo-blue to-talexo-purple ' +
    'hover:from-talexo-blue-dark hover:to-talexo-purple-dark ' +
    'text-white font-semibold transition-all ' +
    'focus:outline-none focus:ring-2 focus:ring-talexo-blue/40 focus:ring-offset-2 ' +
    'disabled:opacity-60 disabled:cursor-not-allowed';

// Secondary / outline action, for pairing beside a primary button.
export const SECONDARY_BTN =
    'bg-white border border-gray-200 text-gray-700 font-semibold transition-colors ' +
    'hover:border-talexo-blue/40 hover:text-talexo-blue ' +
    'focus:outline-none focus:ring-2 focus:ring-talexo-blue/30 ' +
    'disabled:opacity-60 disabled:cursor-not-allowed';

// The same primary treatment for MUI <Button sx={...}>, so components built with
// MUI rather than Tailwind classes still land on one shared look.
export const PRIMARY_BTN_SX = {
    textTransform: 'none',
    fontWeight: 600,
    color: '#fff',
    background: 'linear-gradient(135deg, #0AAAE6 0%, #6428AA 100%)',
    '&:hover': { background: 'linear-gradient(135deg, #0888B8 0%, #4F1F87 100%)' },
    '&.Mui-disabled': { background: '#e5e7eb', color: '#9ca3af' },
    transition: 'all 0.2s',
};

// Filled text field, matching the inputs on the sign-in / register pages:
// grey by default, white with a brand border and ring on focus.
export const FILLED_INPUT_SX = {
    '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        backgroundColor: '#F9FAFB',
        transition: 'background-color 0.2s',
        '& fieldset': { borderColor: 'transparent' },
        '&:hover fieldset': { borderColor: '#B8E4F5' },
        '&.Mui-focused': { backgroundColor: '#fff' },
        '&.Mui-focused fieldset': { borderColor: '#0AAAE6', borderWidth: '1px' },
        '&.Mui-error': { backgroundColor: '#FEF2F2' },
        '&.Mui-error fieldset': { borderColor: '#F87171' },
    },
};
